import React from 'react';

import useStyles from './styles';


const GroupDetails = ({group}) => {
  const classes = useStyles();

  const count = group && group.customers && group.customers.length || 0;

  return (
    <div>
      <p className={classes.groupName}>{group.name}</p>
      <p className={classes.groupDetails}><b>{count} Kunde{count > 1 ? 'n' : ''}</b> in dieser Gruppe</p>
    </div>
  )
};

export default GroupDetails;